import { Injectable } from '@angular/core';
import { timer, Subject } from 'rxjs';
import { map, takeWhile, switchAll } from 'rxjs/operators';

const COUNTDOWN_TIMER_DURATION = 30;
const COUNTDOWN_TIMER_STEP = 1000;

@Injectable({
  providedIn: 'root',
})
export class ResendCodeTimerService {
  resetResendCodeTimer: Subject<number> = new Subject<number>();
  resendCodeTimer: Subject<number> = new Subject<number>();

  constructor() {
    this.resetResendCodeTimer
      .asObservable()
      .pipe(
        map(() => this.getCountdownTimer()),
        switchAll(),
      )
      .subscribe(this.resendCodeTimer);
  }

  getCountdownTimer() {
    return timer(COUNTDOWN_TIMER_DURATION, COUNTDOWN_TIMER_STEP).pipe(
      map(t => COUNTDOWN_TIMER_DURATION - t),
      takeWhile(t => t >= 0),
    );
  }

  getResendCodeTimer() {
    return this.resendCodeTimer;
  }

  getResetResendCodeTimer() {
    return this.resetResendCodeTimer;
  }
}
